import { Component, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { map, Observable, switchMap, take, tap } from 'rxjs';
import { SavedDatabaseModel } from '../../../models/saved/saved-database-model.type';
import { DbmToolComponent } from '../../../components/dbm-tool/dbm-tool/dbm-tool.component';
import { DatabaseModel } from '../../../models/class/database-model.class';
import { AsyncPipe } from '@angular/common';
import { DatabaseModelBuilder } from '../../../models/builder/database-model-builder.class';
import { FormsModule } from '@angular/forms';
import { NgModelDebounceChangeDirective } from './../../../../../../app/core/directives/debounce-time/ng-model-debounce-change.directive';
import { FIRST_OF_OBSERVABLE } from '../../../models/constant/constants.constant';
import { CardListComponent } from '../../../components/cards/card-list/card-list.component';
import { ToolbarComponent } from '../../../../../core/components/toolbar/components/toolbar.component';
import { ToolbarAction } from '../../../../sequence-diagram-page/types/toolbarAction.types';
import { DatabaseModelFacadeService } from '../../../services/database-model-facade/database-model-facade.service';
import { ToastrService } from 'ngx-toastr';
import { SAVE_ICON_SVG, VISUALIZATION_ICON_SVG } from '../../../../../core/components/toolbar/svg/svg-toolbar.constant';
import { DatabaseModelService } from '../../../services/database-model/database-model.service';

@Component({
  selector: 'app-database-model-page',
  standalone: true,
  imports: [DbmToolComponent, AsyncPipe, FormsModule, NgModelDebounceChangeDirective, CardListComponent, ToolbarComponent],
  templateUrl: './database-model-page.component.html',
  styleUrl: './database-model-page.component.scss',
})
export class DatabaseModelPageComponent {
  private readonly _route: ActivatedRoute = inject(ActivatedRoute);
  private readonly _facade: DatabaseModelFacadeService = inject(DatabaseModelFacadeService);
  private readonly _toastr: ToastrService = inject(ToastrService);
  private readonly _router: Router = inject(Router);
  private readonly _dbmService: DatabaseModelService = inject(DatabaseModelService);
  model$: Observable<DatabaseModel> = this._initializeModel().pipe(
    switchMap(() => this._dbmService.getModel$())
  );
  newTitle: string = '';
  isEnglish: boolean = false;

  toolbarActions: ToolbarAction[] = [
    {
      label: 'Enregistrer',
      ariaLabel: 'Sauvegarder le diagramme',
      svg: SAVE_ICON_SVG,
      action: () => this.handleSave(),
    },
    {
      label: 'Visualiser',
      ariaLabel: 'Visualiser le modèle',
      svg: VISUALIZATION_ICON_SVG,
      action: () => this.handleVisualization(),
    },
  ];

  public updateTitle(): void {
    this._facade.updateTitle(this.newTitle);
  }

  public toggleLang(): void {
    this.isEnglish = !this.isEnglish;
  }

  public handleSave(): void {
    this._facade
      .save$()
      .pipe(take(FIRST_OF_OBSERVABLE))
      .subscribe(value => {
        console.log(value);
        if (value === true) this._toastr.success('Modèle sauvegardé');
        else this._toastr.error('Sauvegarde impossible');
      });
  }

  public handleVisualization(): void {
    this._router.navigate(['/display/model']);
  }

  private _initializeModel(): Observable<DatabaseModel> {
    return this._route.params.pipe(
      map((params: Params) => +params['id']),
      switchMap((paramId: number): Observable<SavedDatabaseModel> => this._facade.getSavedDatabaseModel(paramId)),
      map((savedModel: SavedDatabaseModel) => DatabaseModelBuilder.buildFromSavedDto(savedModel)),
      tap((model: DatabaseModel) => (this.newTitle = model.getTitle()))
    );
  }
}
